import { CSSProperties, FC, PropsWithChildren } from 'react'
import { cn } from '@wellesley/ui'

export const HEADER_HEIGHT = 64

type CmpProps = PropsWithChildren<{
  className?: string
  style?: CSSProperties
}>

const HeaderWrapper: FC<CmpProps> = ({ children, className, style }) => {
  return (
    <header
      data-testid="header-wrapper"
      className={cn(
        'flex h-[--HEADER_HEIGHT] w-full items-center justify-between gap-2  bg-white px-4',
        className,
      )}
      style={
        {
          '--HEADER_HEIGHT': `${HEADER_HEIGHT}px`,
          ...style,
        } as CSSProperties
      }
    >
      {children}
    </header>
  )
}

export default HeaderWrapper
